"use client";
import { useRef, useState } from "react";
import ReactDOM from "react-dom";
import { icons } from "./icons";
import PerfectScrollbar from "react-perfect-scrollbar";

export default function DropDown({
	value,
	values,
	onChange,
	className,
	listClassName,
}) {
	className = className || "";
	const [open, setOpen] = useState(false);
	const ddRef = useRef(null);
	listClassName =
		listClassName ||
		"bg-dark-50 shadow-xl shadow-dark-900/10 dark:bg-dark-900 dark:ring-1 ring-dark-700/50";
	const showDD = (ref) => {
		let { top, left, height, width } = ref.current.getBoundingClientRect();
		const shouldBeTop = top > window.outerHeight - 300;

		top = shouldBeTop ? top - 148 : top - height;

		return ReactDOM.createPortal(
			<>
				<div
					className="z fixed inset-0"
					onClick={() => setOpen(false)}
				/>
				<div
					className={
						"fixed -mt-px h-[150px] w-full overflow-hidden rounded-md  p-2 " +
						listClassName
					}
					style={{ left, top: top + height, width }}
				>
					<PerfectScrollbar options={{ wheelPropagation: false }}>
						{values.map((v) => {
							const cl =
								value === v
									? "text-accent-500"
									: "hover:bg-accent-300/20 hover:text-accent-500";
							return (
								<div
									onClick={() => {
										onChange(v);
										setOpen(false);
									}}
									className={
										"flex h-8 cursor-pointer items-center whitespace-nowrap rounded px-3 " +
										cl
									}
									key={v}
								>
									{v}
								</div>
							);
						})}
					</PerfectScrollbar>
				</div>
			</>,
			document.body
		);
	};

	className = className || "bg-dark-50 dark:bg-dark-800/50";
	return (
		<>
			<div
				onClick={() => setOpen(!open)}
				className={
					className +
					" hu flex min-w-[60px] cursor-pointer items-center justify-between rounded "
				}
				ref={ddRef}
			>
				<div className="pl-3">{value}</div>
				<div className="scale-50 px-2 ">{icons.arrowDown}</div>
			</div>
			{open && showDD(ddRef)}
		</>
	);
}
